import $axios from '~/plugins/axios';

import { Api, GetSettingPosTypeParams, PosType } from '~/api';
import { buildModule } from '../utils';
import { createDict, Dict, fetchAllPages } from '~/helpers';

const api = $axios as Api;

type LazyLoadingParams = Omit<GetSettingPosTypeParams, 'limit' | 'offset'>;

export default buildModule()
	.withState({
		posTypeById: {} as Dict<PosType>,
		orderedIds: [] as number[],
		params: {} as LazyLoadingParams,
	})
	.withGetters({
		items: (state) => state.orderedIds.map(id => state.posTypeById[id]),
		byId: (state) => (id: number) => state.posTypeById[id],
	})
	.withMutations({
		RESET (state, params: LazyLoadingParams = {}) {
			state.params = params;
			state.orderedIds = [];
		},
		APPEND_POS_TYPES (state, posTypes: PosType[]) {
			state.posTypeById = { ...state.posTypeById, ...createDict(posTypes, ({ id }) => id) };
			state.orderedIds = Array.from(new Set([ ...state.orderedIds, ...posTypes.map((posType) => posType.id) ]));
		},
		SET_POS_TYPES (state, posTypes: PosType[]) {
			state.posTypeById = { ...state.posTypeById, ...createDict(posTypes, ({ id }) => id) };
		},
	})
	.withActions({
		async getMore ({ state, commit }, limit: number) {
			const params: GetSettingPosTypeParams = { ...state.params, limit, offset: state.orderedIds.length };
			const { data } = await api.get('/setting/pos-type', { params });

			commit('APPEND_POS_TYPES', data.payload);
		},
		async prefetchPosTypes ({ commit }, posTypeIds: number[]) {
			const posTypeGetRequests = posTypeIds.map((id) => api.get(`/setting/pos-type/${ id }`));
			const posTypeResponses = await Promise.all(posTypeGetRequests);

			const posTypes = posTypeResponses.map((resp) => (resp.data as { payload: PosType }).payload);
			commit('SET_POS_TYPES', posTypes);
		},
		async getPosType ({ commit }, posTypeId: number) {
			const response = await api.get(`/setting/pos-type/${ posTypeId }`);

			commit('SET_POS_TYPES', [ (response.data as { payload: PosType }).payload ]);
		},
		async getAll ({ state, commit }, params: LazyLoadingParams = {}) {
			const allParams: GetSettingPosTypeParams = { ...state.params, ...params };
			const items = await fetchAllPages('/setting/pos-type', allParams)<PosType>(api);
			commit('SET_POS_TYPES', items);

			return items;
		},
		resetParams ({ state, commit }, params: LazyLoadingParams = {}) {
			commit('RESET', { ...state.params, ...params });
		},
	});


